import React, { useEffect, useState } from "react";
import Menubar from "../Menubar";
import { Container, Row, Col, Table } from "react-bootstrap";
import { store } from "../../App";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import "jspdf-autotable";
import {
  allowOnlyNumbersandDecimal,
  datetime,
  exportToExcel,
  generatePdf,
  multiGeneratePdf,
  mutliExportToExcel,
} from "../utils/commonFunctions";
import KpiService from "../../Services/KpiService";
import AlertModal from "../Alert/AlertModal";
import useAlert from "../Alert/useAlert";
import { Field, FormikProvider, Form, useFormik } from "formik";
import { FaRegSave } from "react-icons/fa";
import Select from "react-select";
import MasterService from "../../Services/MasterService";

export default function IndicatorwiseTargetsReport() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [search, setSearch] = useState("");

  const [tableData, setTableData] = useState([]);
  const [showTable, setShowTable] = useState(false);

  const [currentdate, setcurrentdate] = useState("");
  const [currenttime, setcurrenttime] = useState("");
  const [deptList, setDeptList] = useState([]);
  const [yearList, setYearList] = useState([]);

  const [level, setLevel] = useState("hod");
  const [selectedDistrictName, setSelectedDistrictName] = useState("");

  const [activeDeptId, setActiveDeptId] = useState("");

  let username = localStorage.getItem("username");
  let districtid = localStorage.getItem("districtid");
  let roleid = localStorage.getItem("role");
  let deptid = localStorage.getItem("deptid");
  // let constId = localStorage.getItem("assemblyid");
  let assembleid = localStorage.getItem("assemblyid");
  const formik = useFormik({
    initialValues: {
      department: "",
      finYear: "",
      type: "",
    },
    onSubmit: (values) => {
      //   getTableReport(values);
    },
  });

  useEffect(() => {
    datetime(setcurrentdate, setcurrenttime);

    let params = { userId: username };

    MasterService.getDeptartments(params)
      .then((res) => {
        if (res?.data?.SDESC) {
          const deptData = res.data.SDESC;

          const updatedList = [{ dept_id: "0", dept_name: "All" }, ...deptData];

          setDeptList(updatedList);
        } else {
          setDeptList([]);
        }
      })
      .catch(() => {
        showAlertMessage("Failed to load departments", "error");
      });

    MasterService.getfinyears()
      .then((res) => {
        if (res?.data) {
          setYearList(res.data);
        }
      })
      .catch(() => {
        showAlertMessage("Failed to load financial years", "error");
      });
    if (
      roleid === "32" ||
      roleid === "60" ||
      roleid === "72" ||
      roleid === "65"
    ) {
      formik.setFieldValue("department", deptid);
    }
  }, []);

  const IndicatorTableReport = (
    values,
    buttonType = "hod",
    districtId = null,
    selectedDeptId = null,
  ) => {
    if (!values.type) return;
    if (!values.department || !values.finYear) return;
    //
    if (buttonType === "hod") {
      setSelectedDistrictName("");
    }

    let params = {
      userId: username,
      // deptId: values.department,
      deptId:
        values.department == "0" && selectedDeptId
          ? selectedDeptId
          : values.department,
      year: values.finYear,
      type: values.type,
      ...(roleid === "65" ? { constId: assembleid } : {}),
    };

    if (values.type === "detailed") {
      params.buttonType = buttonType;
    }

    const finalDistrictId =
      buttonType === "district" && roleid !== "admin"
        ? districtid
        : districtId || districtid || "0";

    if (values.type === "abstract") {
      params.districtId = districtid || "0";
    } else {
      params.districtId = finalDistrictId;
    }

    store.dispatch({ type: "SHOW_SPINNER" });

    KpiService.IndicatorwiseTargetsReport(params)
      .then((res) => {
        if (res?.data?.dataList?.length > 0) {
          setTableData(res.data.dataList);
          setShowTable(true);

          setLevel(values.type === "detailed" ? buttonType : "abstract");
          setActiveDeptId(params.deptId);
        } else {
          setTableData([]);
          setShowTable(false);
          showAlertMessage("No Data Found", "info");
        }
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };

  const filteredData = Array.isArray(tableData)
    ? tableData.filter((item) =>
        Object.values(item).some((value) =>
          value?.toString().toLowerCase().includes(search.toLowerCase()),
        ),
      )
    : [];

  const getRowSpanData = () => {
    let map = {};
    tableData.forEach((item) => {
      if (map[item.dept_name]) {
        map[item.dept_name] += 1;
      } else {
        map[item.dept_name] = 1;
      }
    });
    return map;
  };

  const rowSpanMap = getRowSpanData();

  const hasStateLevel = tableData.some((item) => item.district_id === "55");

  const sourceData = search ? filteredData : tableData;

  const groupedDistrictData = {};

  if (level === "district") {
    sourceData.forEach((item) => {
      const key = item.indicator_name;

      if (!groupedDistrictData[key]) {
        groupedDistrictData[key] = {
          indicator_name: item.indicator_name,
          unit_name: item.unit_name,
          enrty_type: item.enrty_type,
          dept_name: item.dept_name,
          dept_id: item.dept_id,
          districts: {},
        };
      }

      groupedDistrictData[key].districts[item.district_name] =
        item.targets_2025 ?? "-";
    });
  }

  const groupedData = {};

  if (level === "mandal") {
    sourceData.forEach((item) => {
      const key = item.indicator_name;

      if (!groupedData[key]) {
        groupedData[key] = {
          indicator_name: item.indicator_name,
          unit_name: item.unit_name,
          enrty_type: item.enrty_type,
          dept_name: item.dept_name,
          mandals: {},
        };
      }

      groupedData[key].mandals[item.mandal_name] = item.targets_2025 ?? "-";
    });
  }

  const districtList =
    level === "district"
      ? (() => {
          const list = [
            ...new Set(sourceData.map((item) => item.district_name)),
          ];

          const stateIndex = list.findIndex((d) => d === null);
          if (stateIndex !== -1) {
            const [state] = list.splice(stateIndex, 1);
            list.unshift(state);
          }

          return list;
        })()
      : [];

  const mandalList =
    level === "mandal"
      ? [
          ...new Set(
            sourceData
              ?.filter((item) => item?.mandal_name !== null)
              .map((item) => item.mandal_name),
          ),
        ]
      : [];
  const secretariat_name =
    formik.values.department === "0" && level !== "hod" && tableData.length > 0
      ? tableData[0]?.secretariat_name || ""
      : "";

  const dept_name =
    level !== "hod" && tableData.length > 0
      ? tableData[0]?.dept_name || ""
      : "";

  const isAllDept =
    formik.values.department === "0" || formik.values.department === "ALL";
  const isDistrictUser = roleid === "32" || roleid === "2" || roleid === "64";
  // const showHodColumn = level === "hod" || isDistrictUser;
  const showHodColumn = level === "hod" || isDistrictUser || roleid === "65";
  // && isAllDept

  const isCvapuUser = roleid === "65";

  const baseColSpan =
    level === "hod"
      ? showHodColumn
        ? 7
        : 6
      : level === "district"
        ? (showHodColumn ? 6 : 5) + districtList.length
        : (showHodColumn ? 5 : 4) + (hasStateLevel ? 1 : 0) + mandalList.length;

  const sortedData = [...filteredData].sort((a, b) =>
    a.dept_name?.localeCompare(b.dept_name),
  );

  const getHodRowSpan = (data) => {
    const map = {};
    data.forEach((item) => {
      map[item.dept_name] = (map[item.dept_name] || 0) + 1;
    });
    return map;
  };

  const groupedDisplayData = {};
  const displayData = sortedData;
  const deptHasTargetMap = {};
  displayData.forEach((row) => {
    const hasValue = row.targets_2025 && !["", "-"].includes(row.targets_2025);

    if (hasValue) {
      deptHasTargetMap[row.dept_name] = true;
    }
  });

  displayData.forEach((item) => {
    const dept = item.dept_name || "Unknown";
    if (!groupedDisplayData[dept]) {
      groupedDisplayData[dept] = [];
    }
    groupedDisplayData[dept].push(item);
  });

  let searialNo = 0;
  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "97%" }}>
        {" "}
        <div className="sa-title">
          {" "}
          <h2>
            {" "}
            Indicator Wise Targets<span> Abstract/Detailed Report</span>{" "}
          </h2>{" "}
        </div>{" "}
      </Container>
      <Container
        fluid
        style={{ width: "97%" }}
        className="outer-page-content-container"
      >
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className="mandal-container py-2 px-4 mb-3">
              <Row className="align-items-end">
                <Col xs={12} sm={12} lg={3}>
                  <label className="mb-1 fw-bold"> Department </label>
                  <span style={{ color: "red" }}> *</span>

                  <Select
                    name="department"
                    options={deptList.map((item) => ({
                      value: item.dept_id,
                      label: item.dept_name,
                    }))}
                    value={
                      deptList
                        .map((item) => ({
                          value: item.dept_id,
                          label: item.dept_name,
                        }))
                        .find(
                          (opt) => opt.value === formik.values.department,
                        ) || null
                    }
                    onChange={(option) => {
                      const deptValue = option?.value || "";

                      formik.setFieldValue("department", deptValue);
                      formik.setFieldValue("finYear", "");
                      setSearch("");
                      formik.setFieldValue("type", "");
                      setTableData([]);
                      setShowTable(false);
                      setSelectedDistrictName("");
                      setLevel("hod");
                    }}
                    placeholder="--Select Department--"
                    isClearable
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    isDisabled={
                      roleid === "32" || roleid === "60" || roleid === "72"
                    }
                  />
                </Col>

                <Col xs={12} sm={12} lg={3}>
                  <label className="mb-1 fw-bold"> Financial Year </label>
                  <span style={{ color: "red" }}> *</span>

                  <Select
                    name="finYear"
                    options={yearList.map((item) => ({
                      value: item.id,
                      label: item.value,
                    }))}
                    value={
                      yearList
                        .map((item) => ({
                          value: item.id,
                          label: item.value,
                        }))
                        .find((opt) => opt.value === formik.values.finYear) ||
                      null
                    }
                    onChange={(option) => {
                      const yearValue = option?.value || "";

                      formik.setFieldValue("finYear", yearValue);
                      setSearch("");
                      formik.setFieldValue("type", "");
                      setTableData([]);
                      setShowTable(false);
                      setSelectedDistrictName("");
                      setLevel("hod");
                    }}
                    placeholder="--Select Year--"
                    isClearable
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </Col>
                <Col xs={12} sm={12} lg={3}>
                  <label className="mb-1 fw-bold"> Type </label>
                  <span style={{ color: "red" }}> *</span>

                  <Select
                    name="type"
                    options={[
                      { value: "abstract", label: "Abstract" },
                      { value: "detailed", label: "Detailed" },
                    ]}
                    value={
                      formik.values.type
                        ? {
                            value: formik.values.type,
                            label:
                              formik.values.type === "abstract"
                                ? "Abstract"
                                : "Detailed",
                          }
                        : null
                    }
                    onChange={(option) => {
                      const typeValue = option?.value || "";

                      formik.setFieldValue("type", typeValue);

                      setSearch("");
                      setTableData([]);
                      setShowTable(false);
                      setSelectedDistrictName("");

                      if (!formik.values.department || !formik.values.finYear) {
                        showAlertMessage(
                          "Please select Department & Financial Year",
                          "error",
                        );
                        return;
                      }

                      setTimeout(() => {
                        if (
                          roleid === "32" ||
                          roleid === "2" ||
                          roleid === "64"
                        ) {
                          IndicatorTableReport(
                            { ...formik.values, type: typeValue },
                            "district",
                          );
                        } else if (roleid === "65") {
                          IndicatorTableReport(
                            { ...formik.values, type: typeValue },
                            "mandal",
                          );
                        } else {
                          IndicatorTableReport(
                            { ...formik.values, type: typeValue },
                            "hod",
                          );
                        }
                      }, 0);
                    }}
                    placeholder="--Select Type--"
                    isClearable
                  />
                </Col>
              </Row>
            </div>
          </Form>
        </FormikProvider>

        {showTable && (
          <>
            <Row className="align-items-center">
              <Col xs={12} sm={12} md={3} lg={3} className="mb-3">
                <div
                  style={{
                    display: "flex",
                    border: "1px solid #ddd",
                    alignItems: "center",
                    borderRadius: "20px",
                    backgroundColor: "#fff",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    padding: "5px 10px",
                  }}
                >
                  <AiOutlineSearch className="me-2" style={{ color: "#888" }} />
                  <input
                    type="text"
                    // placeholder={`records: ${tableData?.length || 0}`}
                    placeholder="search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                      flex: "1",
                      border: "none",
                      outline: "none",
                      background: "transparent",
                    }}
                  />
                </div>
              </Col>

              <Col className="mb-3 text-end">
                {formik.values.type === "detailed" &&
                  level !== "hod" &&
                  roleid !== "65" &&
                  !(
                    (roleid === "32" || roleid === "2" || roleid === "64") &&
                    level === "district"
                  ) && (
                    <button
                      className="btn btn-secondary btn-sm mx-2"
                      onClick={() => {
                        setSearch("");

                        if (level === "mandal") {
                          setSelectedDistrictName("");

                          IndicatorTableReport(
                            formik.values,
                            "district",
                            districtid,
                            isDistrictUser && formik.values?.department === "0"
                              ? "0"
                              : activeDeptId,
                          );
                        } else if (level === "district") {
                          setSelectedDistrictName("");
                          IndicatorTableReport(formik.values, "hod");
                        }
                      }}
                    >
                      Back
                    </button>
                  )}
                <button
                  className="btn btn-danger btn-sm mx-2"
                  onClick={() =>
                    generatePdf("#my-table", "indicatorwiseTargetsReport")
                  }
                >
                  PDF <MdOutlinePictureAsPdf />
                </button>

                <button
                  className="btn btn-success btn-sm"
                  onClick={() =>
                    exportToExcel("my-table", "IndicatorwiseTargetsReport")
                  }
                >
                  Excel <AiFillFileExcel />
                </button>
              </Col>
            </Row>

            <div
              style={{ textAlign: "center", backgroundColor: "#d4e3d8" }}
              className="rounded-1 border py-1"
            >
              <span className="style">
                Statement showing the Indicator wise State and District Targets
                for the Financial Year: &nbsp;
                <span style={{ color: "#0d6efd", fontWeight: "bold" }}>
                  {formik.values.finYear || ""}
                </span>
                <br />
                {/* /-------------sec............... */}
                {isAllDept &&
                  !isDistrictUser &&
                  !isCvapuUser &&
                  level !== "hod" &&
                  !isCvapuUser &&
                  formik.values.type === "detailed" && (
                    <span style={{ fontSize: "14px" }}>
                      Secretariat Name :{" "}
                      <a style={{ textDecoration: "none", color: "#0d6efd" }}>
                        {secretariat_name}
                      </a>
                      ,&nbsp;
                    </span>
                  )}
                {/* //----------------dept............. */}
                {formik.values.type === "detailed" &&
                  level !== "hod" &&
                  !isCvapuUser &&
                  (!isDistrictUser || !isAllDept) && (
                    <span style={{ fontSize: "14px" }}>
                      Dept Name :{" "}
                      <a style={{ textDecoration: "none", color: "#0d6efd" }}>
                        {dept_name}
                      </a>{" "}
                      &nbsp;
                    </span>
                  )}
                {/* ----------------------district------------- */}
                {level !== "hod" && selectedDistrictName && !isCvapuUser && (
                  <>
                    &nbsp; District:{" "}
                    <span style={{ fontSize: "14px" }}>
                      <a style={{ textDecoration: "none", color: "#0d6efd" }}>
                        {selectedDistrictName}
                      </a>
                    </span>
                  </>
                )}
              </span>

              <div className="text-end style-1">
                Report On : {currentdate} {currenttime}
              </div>
            </div>

            <div className="my-2">
              <div>
                <Row>
                  <div className="table-container">
                    {formik.values.type === "abstract" && (
                      <Table
                        bordered
                        id="my-table"
                        className="table table-bordered custom-table table-responsive sticky-table w-100"
                      >
                        <thead className="table-primary text-center">
                          <tr>
                            <th rowSpan="2">S.No</th>
                            <th rowSpan="2">Department</th>

                            <th colSpan="4" style={{ textAlign: "center" }}>
                              Indicators
                            </th>

                            <th colSpan="3" style={{ textAlign: "center" }}>
                              Targets
                            </th>
                          </tr>

                          <tr>
                            <th>Total</th>
                            <th>Sec.</th>
                            <th>District</th>
                            <th>Mandal/Ulb</th>

                            <th>Sec./Hod</th>
                            <th>District</th>
                            <th>Mandal/Ulb</th>
                          </tr>
                        </thead>

                        <tbody className="text-center">
                          {filteredData?.length > 0 ? (
                            filteredData?.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.dept_name}</td>

                                <td style={{ textAlign: "right" }}>
                                  {item.tot_ind ?? "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {item.state_ind_count ?? "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {item.district_ind_count ?? "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {item.mandal_ind_count ?? "-"}
                                </td>

                                <td style={{ textAlign: "right" }}>
                                  {item.state_tr_count ?? "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {item.district_tr_count ?? "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {item.mandal_tr_count ?? "-"}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="9">No Data Found</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    )}
                    {formik.values.type === "detailed" && (
                      <div className="rt-wrapper">
                        <Table
                          bordered
                          id="my-table"
                          className="table table-bordered custom-table sticky-table w-100"
                        >
                          <thead
                            className={`text-center ${
                              level === "district"
                                ? "table-primary"
                                : "table-dark"
                            }`}
                          >
                            <tr>
                              <th
                                className="sticky-col sticky-sno"
                                style={{ minWidth: "60px" }}
                              >
                                S.No
                              </th>

                              {/* {level === "hod" && <th>HOD Name</th>} */}
                              {showHodColumn && (
                                <th className="sticky-col sticky-KPIHOD">
                                  HOD Name
                                </th>
                              )}

                              <th
                                className="sticky-col sticky-indicator"
                                style={{ minWidth: "450px" }}
                              >
                                Indicators
                              </th>

                              <th className="sticky-col sticky-unit">Unit</th>

                              <th
                                className="sticky-col sticky-KPIENTRY"
                                style={{ minWidth: "140px" }}
                              >
                                Entry Level
                              </th>

                              {level !== "district" && level !== "mandal" && (
                                <th>Targets</th>
                              )}

                              {/* ================= DISTRICT LEVEL ================= */}
                              {level === "district" &&
                                districtList.map((dist, i) => {
                                  const isStateLevel = dist === null;

                                  const hasMandalEntry = tableData.some(
                                    (item) =>
                                      item.district_name === dist &&
                                      item.enrty_type?.toLowerCase() ===
                                        "mandal",
                                  );

                                  return (
                                    <th
                                      key={i}
                                      ref={(el) => {
                                        if (el) {
                                          if (isStateLevel || isDistrictUser) {
                                            el.style.setProperty(
                                              "color",
                                              "#ffffff",
                                              "important",
                                            );
                                          } else {
                                            el.style.setProperty(
                                              "color",
                                              "orange",
                                              "important",
                                            );
                                          }
                                        }
                                      }}
                                      className={
                                        isStateLevel ? "sticky-col" : ""
                                      }
                                      style={{
                                        position: isStateLevel
                                          ? "sticky"
                                          : "relative",
                                        left: isStateLevel ? "550px" : "auto",
                                        zIndex: isStateLevel ? 15 : "auto",
                                        // background: isStateLevel ? "#fff" : "",
                                        cursor:
                                          !isStateLevel && hasMandalEntry
                                            ? "pointer"
                                            : "default",
                                        fontWeight: "600",
                                        textDecoration:
                                          isStateLevel ||
                                          !hasMandalEntry ||
                                          isDistrictUser
                                            ? "none"
                                            : "underline",
                                        color: isStateLevel ? "#fff" : "orange",
                                      }}
                                      title={
                                        isStateLevel
                                          ? "State Level"
                                          : hasMandalEntry
                                            ? "Click to view mandals"
                                            : "No mandal data"
                                      }
                                      onClick={() => {
                                        if (isDistrictUser) {
                                          return;
                                        }
                                        if (isStateLevel || !hasMandalEntry)
                                          return;

                                        const selected = tableData.find(
                                          (d) => d.district_name === dist,
                                        );

                                        setSelectedDistrictName(dist);

                                        IndicatorTableReport(
                                          formik.values,
                                          "mandal",
                                          selected?.district_id,
                                          selected?.dept_id,
                                        );
                                      }}
                                    >
                                      {isStateLevel
                                        ? "State Level"
                                        : isDistrictUser
                                          ? "Targets"
                                          : dist}
                                    </th>
                                  );
                                })}

                              {/* ================= MANDAL LEVEL ================= */}
                              {level === "mandal" && hasStateLevel && (
                                <th className="sticky-col sticky-state">
                                  State Level
                                </th>
                              )}

                              {level === "mandal" && roleid !== "65" && (
                                <th>District Level</th>
                              )}

                              {level === "mandal" &&
                                mandalList.map((mandal, index) => (
                                  <th key={index}>{mandal}</th>
                                ))}
                            </tr>
                          </thead>

                          <tbody className="text-center">
                            {/* ================= DISTRICT BODY ================= */}
                            {level === "district" ? (
                              Object.values(groupedDistrictData).length > 0 ? (
                                <>
                                  {(() => {
                                    const renderedDept = {};

                                    return Object.values(
                                      groupedDistrictData,
                                    ).map((row, index, arr) => {
                                      const isFirst =
                                        !renderedDept[row.dept_name];

                                      let span = 0;
                                      if (isFirst) {
                                        span = arr.filter(
                                          (r) => r.dept_name === row.dept_name,
                                        ).length;
                                        renderedDept[row.dept_name] = true;
                                      }

                                      return (
                                        <tr key={index}>
                                          <td className="sticky-col sticky-sno">
                                            {index + 1}
                                          </td>

                                          {showHodColumn && isFirst && (
                                            <td
                                              rowSpan={span}
                                              className="sticky-col sticky-KPIHOD"
                                              style={{
                                                verticalAlign: "top",
                                                color: "blue",
                                                cursor: "pointer",
                                              }}
                                              onClick={() => {
                                                IndicatorTableReport(
                                                  formik.values,
                                                  "mandal",
                                                  row?.district_id,
                                                  row?.dept_id,
                                                );
                                              }}
                                            >
                                              {row.dept_name || "-"}
                                            </td>
                                          )}

                                          <td
                                            className="sticky-col sticky-indicator"
                                            style={{ minWidth: "450px" }}
                                          >
                                            {row.indicator_name}
                                          </td>

                                          <td className="sticky-col sticky-unit">
                                            {row.unit_name}
                                          </td>

                                          <td className="sticky-col sticky-KPIENTRY">
                                            {row.enrty_type}
                                          </td>

                                          {districtList.map((dist, i) => {
                                            const isStateLevel = dist === null;

                                            return (
                                              <td
                                                key={i}
                                                className={
                                                  isStateLevel
                                                    ? "sticky-col"
                                                    : ""
                                                }
                                                style={{
                                                  position: isStateLevel
                                                    ? "sticky"
                                                    : "relative",
                                                  left: isStateLevel
                                                    ? "550px"
                                                    : "auto",
                                                  zIndex: isStateLevel
                                                    ? 10
                                                    : "auto",
                                                  textAlign: "right",
                                                }}
                                              >
                                                {row.districts[dist] ?? "-"}
                                              </td>
                                            );
                                          })}
                                        </tr>
                                      );
                                    });
                                  })()}
                                </>
                              ) : (
                                <tr>
                                  <td colSpan={baseColSpan}>No Data Found</td>
                                </tr>
                              )
                            ) : level === "mandal" ? (
                              Object.values(groupedData).length > 0 ? (
                                Object.values(groupedData).map(
                                  (row, index, arr) => {
                                    const isFirstRow =
                                      index === 0 ||
                                      arr[index - 1]?.dept_name !==
                                        row.dept_name;

                                    const rowSpanCount = arr.filter(
                                      (r) => r.dept_name === row.dept_name,
                                    ).length;
                                    const stateValue = tableData.find(
                                      (item) =>
                                        item.indicator_name ===
                                          row.indicator_name &&
                                        item.district_id === "55",
                                    );

                                    const districtValue = tableData.find(
                                      (item) =>
                                        item.indicator_name ===
                                          row.indicator_name &&
                                        item.district_id !== "0" &&
                                        (item.mandal_id === "0" ||
                                          item.mandal_id === null),
                                    );

                                    return (
                                      <tr key={index}>
                                        <td className="sticky-col sticky-sno">
                                          {index + 1}
                                        </td>

                                        {showHodColumn && isFirstRow && (
                                          <td
                                            rowSpan={rowSpanCount}
                                            className="sticky-col sticky-KPIHOD"
                                            style={{ verticalAlign: "top" }}
                                          >
                                            {row.dept_name || "-"}
                                          </td>
                                        )}

                                        <td className="sticky-col sticky-indicator">
                                          {row.indicator_name}
                                        </td>

                                        <td className="sticky-col sticky-unit">
                                          {row.unit_name}
                                        </td>

                                        <td className="sticky-col sticky-KPIENTRY">
                                          {row.enrty_type}
                                        </td>

                                        {hasStateLevel && (
                                          <td className="sticky-col sticky-state">
                                            {stateValue?.targets_2025 ?? "-"}
                                          </td>
                                        )}
                                        {roleid !== "65" && (
                                          <td style={{ textAlign: "right" }}>
                                            {districtValue?.targets_2025 ?? "-"}
                                          </td>
                                        )}
                                        {mandalList.map((mandal, i) => (
                                          <td
                                            key={i}
                                            style={{ textAlign: "right" }}
                                          >
                                            {row.mandals[mandal] ?? "-"}
                                          </td>
                                        ))}
                                      </tr>
                                    );
                                  },
                                )
                              ) : (
                                <tr>
                                  <td colSpan={baseColSpan}>No Data Found</td>
                                </tr>
                              )
                            ) : filteredData.length > 0 ? (
                              Object.entries(groupedDisplayData).map(
                                ([deptName, rows]) => {
                                  return rows.map((item, index) => {
                                    const isFirst = index === 0;

                                    const isClickable =
                                      deptHasTargetMap[deptName];

                                    return (
                                      <tr key={item.indicator_id}>
                                        <td className="sticky-col sticky-sno">
                                          {++searialNo}
                                        </td>

                                        {showHodColumn && isFirst && (
                                          <td
                                            rowSpan={rows.length}
                                            className="sticky-col sticky-KPIHOD"
                                            style={{
                                              verticalAlign: "top",
                                              cursor: isClickable
                                                ? "pointer"
                                                : "default",
                                              color: isClickable
                                                ? "blue"
                                                : "#212529",
                                            }}
                                            onClick={() => {
                                              if (!isClickable) return;

                                              IndicatorTableReport(
                                                formik.values,
                                                // "district",
                                                roleid === "65"
                                                  ? "mandal"
                                                  : "district",
                                                null,
                                                item.dept_id,
                                              );
                                            }}
                                          >
                                            {deptName}
                                          </td>
                                        )}

                                        <td className="sticky-col sticky-indicator">
                                          {item.indicator_name}
                                        </td>

                                        <td className="sticky-col sticky-unit">
                                          {item.unit_name}
                                        </td>

                                        <td className="sticky-col sticky-KPIENTRY">
                                          {item.enrty_type}
                                        </td>

                                        <td style={{ textAlign: "right" }}>
                                          {item.targets_2025 ?? "-"}
                                        </td>
                                      </tr>
                                    );
                                  });
                                },
                              )
                            ) : (
                              <tr>
                                <td colSpan={baseColSpan}>No Data Found</td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    )}
                  </div>
                </Row>
              </div>
            </div>
          </>
        )}
      </Container>
      <AlertModal
        show={showAlert}
        titleText={alertData.titleText}
        alertText={alertData.alertText}
        onClose={closeAlert}
      />
    </>
  );
}
